import type { Primitive } from '#types/primitive.type';

import { isNotDefined } from './is-not-defined.guard';
import { isTypeOf } from './is-type-of.guard';

/**
 * Type guard that checks if the provided value is a primitive type.
 *
 * A value is considered primitive if it is one of the following types:
 * - `bigint`
 * - `boolean`
 * - `number`
 * - `string`
 * - `symbol`
 *
 * If the value is `null` or `undefined`, it is also considered primitive.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a primitive type, otherwise `false`.
 */
export const isPrimitive = (value: unknown): value is Primitive => {
  if (isNotDefined(value)) {
    return true;
  }

  return isTypeOf(value, 'bigint', 'boolean', 'number', 'string', 'symbol');
};
